import { FormFieldTypes } from "../../../data/formFieldType";

export const viewResourcesFormData = {
  name: "ViewResourcesForm",
  initialState: {
    category: null,
    document: null,
    membershipType: null,
  },
  formFields: [
    {
      id: "category",
      lable: "Category",
      Field_Name: "Category",
      fieldType: FormFieldTypes.SELECT,
      dataField: "category",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      style: {
        containerCss: "col-lg-4 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "document",
      lable: "Search by Document",
      Field_Name: "Search by Document",
      fieldType: FormFieldTypes.INPUT,
      dataField: "document",
      fieldSetting: {
        placeholder: "",
      },
      style: {
        containerCss: "col-lg-4 col-md-6 col-sm-12 mb-3",
      },
    },
    {
      id: "membershipType",
      lable: "Membership Type",
      Field_Name: "Membership Type",
      fieldType: FormFieldTypes.SELECT,
      dataField: "membershipType",
      fieldSetting: {
        placeholder: "Select",
        options: [], 
      },
      style: {
        containerCss: "col-lg-4 col-md-6 col-sm-12 mb-3",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
